import React, { } from "react";
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Login from "./containers/Login";
import Header from "./components/Header";
import { createMuiTheme } from '@material-ui/core/styles';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react';
import reducer from "../src/redux/reducer/index";
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';

const enhancers = [applyMiddleware(thunk)];
const composeEnhancers = process.env.NODE_ENV !== 'production'
  && typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  })
  : compose;
const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)

const store = createStore(persistedReducer, composeEnhancers(...enhancers))

function App() {
  let persist = persistStore(store)
  return (
    // <ThemeProvider theme={theme}>
    <Provider store={store}>
      <div>
        <PersistGate loading={null} persistor={persist}>
          <Router>
            <Switch>
              <Route exact path="/" component={Login}></Route>
              <Route path="/" component={Header}></Route>
              {/* <Route path="/" component={ZNav}></Route> */}
            </Switch>
          </Router>
        </PersistGate>
      </div>
    </Provider>
    // </ThemeProvider>
  );
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "##92278F",
    },
    secondary: {
      main: "##f7941d"
    },
  },
});

export default App;
